export const PEOPLE_SECTION_LABEL =
  'mb-2 ml-1 text-xs font-semibold uppercase tracking-wider text-[var(--fl-text-2)]'
export const PEOPLE_CARD =
  'overflow-hidden rounded-2xl border border-[var(--fl-border)] bg-[var(--fl-surface)] shadow-[var(--card-shadow-sm)]'
/** Phone: a stacked row. md+: a table row with these columns. */
export const PEOPLE_TABLE_COLUMNS = 'md:grid md:grid-cols-[2fr_1fr_1fr_1fr_1.2fr] md:gap-4'
